import { FieldType } from '@wix/wix-data-schema-types'
import type { FieldSpec } from '@wix/wix-data-schema-types'
import type { DigestedSchemaField } from '@wix/wix-data-client-common-standalone'
import supportedConditions from '../../supportedConditions'
import type { DatasetType } from '@wix/wix-data-client-types'
import {
  ROUTER_DATASET,
  DATASET,
  WIDGET_DATASET,
} from '@wix/wix-data-client-types'
import { fieldNameMatches } from './fieldQueries'
import { getAllowedConditions } from './filterConditions'
const { reference, multiReference } = FieldType

const supportedTypes = Object.keys(supportedConditions)

const supportedFieldTypesByDatasetType: Record<DatasetType, string[]> = {
  [DATASET]: supportedTypes,
  [WIDGET_DATASET]: [],
  [ROUTER_DATASET]: supportedTypes.filter(
    type => type !== reference && type !== multiReference,
  ),
}

const isRouterDataset = (datasetType: DatasetType) =>
  datasetType === ROUTER_DATASET

const isFieldTypeSupported = (field: FieldSpec, datasetType: DatasetType) =>
  supportedFieldTypesByDatasetType[datasetType].includes(field.type)

const isFieldNotBlacklisted = (field: DigestedSchemaField) =>
  !fieldNameMatches(field, '_id')

const isFieldOfSufficientQueryOperators = (field: FieldSpec) => {
  const { type, queryOperators } = field

  const allowedConditions = getAllowedConditions(
    // @ts-expect-error TODO
    supportedConditions[type],
    queryOperators,
  )

  return allowedConditions.length > 0
}

const isFieldAllowedIfOwner = (
  field: DigestedSchemaField,
  datasetType: DatasetType,
) => {
  const fieldIsOwner = fieldNameMatches(field, '_owner')

  if (!fieldIsOwner) {
    return true
  }

  return !isRouterDataset(datasetType)
}

export default (datasetType: DatasetType, field: DigestedSchemaField) =>
  [
    isFieldTypeSupported,
    isFieldNotBlacklisted,
    isFieldOfSufficientQueryOperators,
    isFieldAllowedIfOwner,
  ].every(rule => rule(field, datasetType))
